import { fetchAPI } from "../../redux/api";

const read = async responsePromise => {
  const response = await responsePromise;
  if (response.ok) return response.status === 204 ? null : response.json();
  let message = "Kitchen display request failed.";
  try {
    const body = await response.json();
    const validationMessage = body.errors && Object.values(body.errors).flat().find(Boolean);
    message = body.message || body.detail || validationMessage || body.title || message;
  } catch (_) {}
  const error = new Error(message); error.status = response.status; throw error;
};
export const getStations = () => read(fetchAPI("kds/stations"));
export const saveStation = station => read(fetchAPI("kds/stations", station, "POST"));
export const saveRoutes = (stationId, categoryIds, menuIds = []) => read(fetchAPI(`kds/stations/${stationId}/routes`, { categoryIds, menuIds }, "PUT"));
export const getKdsBoard = stationId => read(fetchAPI(`kds/board?stationId=${stationId}`));
export const getKdsActivity = (stationId, minutes = 60) => read(fetchAPI(`kds/activity?stationId=${stationId}&minutes=${minutes}`));
export const updateKdsStatus = (stateId, status, expectedStatus, reason = null) => read(fetchAPI(`kds/items/${stateId}/status`, { status, expectedStatus, reason }, "PATCH"));
export const recallKdsItem = (stateId, reason) => read(fetchAPI(`kds/items/${stateId}/recall`, { reason }, "POST"));
export const cancelKdsItem = (stateId, reason) => read(fetchAPI(`kds/items/${stateId}/cancel`, { reason }, "POST"));
export const getKdsMetrics = stationId => read(fetchAPI(`kds/metrics?stationId=${stationId}`));
